import React from 'react'

const SectionTitle = ({ badge, title, highlightedText, description }) => {
  return (
    <div className="text-center mb-16">
      {badge && (
        <span className="inline-block mb-3 px-3 py-1 bg-red-600/20 border border-red-600/30 rounded-sm text-red-500 text-xs uppercase tracking-wider font-semibold">
          {badge}
        </span>
      )}
      <h2 className="font-title text-4xl font-bold text-white mb-4">
        {title} {highlightedText && <span className="text-red-600">{highlightedText}</span>}
      </h2>
      <div className="w-20 h-1 bg-red-600 mx-auto mb-6"></div>
      {description && (
        <p className="text-gray-400 max-w-2xl mx-auto">
          {description}
        </p>
      )}
    </div>
  );
};

export default SectionTitle